export * from "./confluence-pricing-page-v2.template.tsx";
